import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CookieService {
    /**
     * Save a cookie on the client computer.
     * @param cookieName The name of the cookie
     * @param cookieValue The value of the cookie. Allways a string, us e JSON.stringify() and if you need an object in another format to be stored.
     * @param storageDays The amount of days this cookie will be stored on the computer of the user
     */
    setCookie(cookieName: string, cookieValue: string, storageDays: number): void {
        const date = new Date();
        date.setTime(date.getTime() + (storageDays * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
    }

    /**
     * Retreive a cookie from the client computer
     * @param cookieName The name of the cookie to retreive
     * @returns Cookie in string, if it was an object, use JSON.parse(), undefined if no cookie is found
     */
    getCookie(cookieName: string): string | undefined {
        const name = `${cookieName}=`;
        const cookieSplit = document.cookie.split(';');
        for (const cookieParts of cookieSplit) {
            let cookie = cookieParts;
            while (cookie.startsWith(' ')) {
                cookie = cookie.substring(1);
            }
            if (cookie.startsWith(name)) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return undefined;
    }
}
